import { useEffect } from 'react';
import type { Route } from './app-routes';
import type { Route as RouteRevamp } from './app-routes-revamp';

export function usePreload(routes: (Route | RouteRevamp)[]) {
  useEffect(() => {
    routes.forEach((route) => {
      Object.values(route).forEach((Component) => {
        if (
          Component instanceof Object &&
          typeof Component.preload === 'function'
        ) {
          Component.preload();
        }
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
